import { StrictDateRange } from '../../../../features/commonUI/DateRangeFilterSelect/types';
import { useGetSizeReportQuery } from '../../impl/wrangler/endpoints/blueberry';
import { SizeReportRequest } from '../../impl/wrangler/schemas/sizeReportRequest';

export const useBlueberrySizeReport = (
  customerId: string | undefined,
  dateRange: StrictDateRange | undefined
) => {
  const requestBody: SizeReportRequest = {
    meta: {},
    data: {
      customer_id: customerId || '',
      start_date: dateRange?.start?.toISOString() || '',
      end_date: dateRange?.end?.toISOString() || '',
    },
  };

  const { data, isLoading, isFetching } = useGetSizeReportQuery(requestBody, {
    skip: !customerId || !dateRange?.start || !dateRange.end,
  });

  return {
    blueberrySizeReportData: data,
    isBlueberrySizeReportLoading: isLoading || isFetching,
  };
};
